import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { uniqBy } from 'lodash';
import { db } from '../firebase';
import { AGENCIES_COLLECTION, DEPARTURES_COLLECTION, ENTERPRISES_COLLECTION } from "../constants/collections";
import { ENTERPRISE_DOC_ID } from "../constants/configs";

const getDepartures = async () => {
  const dateNow = new Date();
  const ref = query(
    collection(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, DEPARTURES_COLLECTION),
    where('date', '>=', dateNow.getTime().toString()),
    orderBy('date', 'asc')
  );
  const querySnapshot = await getDocs(ref);
  const departures = querySnapshot.docs.map((doc) => doc.data());
  return departures;
};

const getAgencies = async () => {
  const q = query(collection(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, AGENCIES_COLLECTION));
  const querySnapshot = await getDocs(q);
  const agencies = querySnapshot.docs.map((doc) => doc.data());

  return uniqBy(agencies, (a) => a.address.country);
};

export { getDepartures, getAgencies };
